import React from "react";
import { CopyToClipboardButton, Loader } from "elements";
import { infiniteNestLink, Link, Route, Switch } from "polyrouter";
import { Trans, useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { StartTrialModal } from "./StartTrial/StartTrialModal";
import { useGetTrialSubscription } from "./useTrial";
import {
  CLARITI_TRIAL_TELL_ME_MORE_URL,
  CLARITI_TRIAL_WELCOME_VIDEO_ID
} from "Constants";
import { YouTubePlayer } from "elements/YouTubePlayer";

export const Trial: React.FC = () => {
  const { t } = useTranslation();
  const { Content } = Layout;
  let { data, fetching, error, executor } = useGetTrialSubscription();

  const refresh = () => {
    executor({ requestPolicy: "network-only" });
  };

  return (
    <Content className="trial-content">
      <Loader loading={fetching}>
        <Content.Title className="mb-5">{t("WELCOME_TO_TRIAL")}</Content.Title>
        <div>
          <Trans i18nKey="CLARITI_TRIAL_DESCRIPTION"></Trans>
        </div>
        <div className="mv-14">
          <YouTubePlayer
            id="claritiTrialVideo"
            title={t("CLARITI_TRIAL_WELCOME_VIDEO_TITLE")}
            videoId={CLARITI_TRIAL_WELCOME_VIDEO_ID}
          />
        </div>
        <div className="mb-1">
          <Trans i18nKey="CLARITI_TRIAL_INTENT"></Trans>
        </div>
        {error ? (
          <>
            <div className="mb-14 font-red">
              <Trans i18nKey="CLARITI_TRIAL_MEETING_STATUS_ERROR"></Trans>
            </div>
            <div className="grouping">
              <button onClick={refresh} className="btn btn-primary">
                {t("REFRESH")}
              </button>
            </div>
          </>
        ) : (
          <>
            {data ? (
              <>
                <div className="mb-14">
                  <Trans i18nKey="CLARITI_TRIAL_SUCCESSFULLY_ENROLLED"></Trans>
                </div>
                <div className="grouping">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={data.meetingUrl}
                    className="btn btn-primary"
                  >
                    {t("JOIN_MY_MEETING")}
                  </a>
                  <CopyToClipboardButton
                    name="meetingUrl"
                    id="meetingUrl"
                    notifyName={t("MEETING_URL")}
                    getTextToCopy={() => data!.meetingUrl}
                    className="btn"
                  >
                    {t("COPY_MEETING_URL")}
                  </CopyToClipboardButton>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={CLARITI_TRIAL_TELL_ME_MORE_URL}
                    className="btn"
                  >
                    {t("CLARITI_TELL_ME_MORE")}
                  </a>
                </div>
              </>
            ) : (
              <div className="grouping">
                <Link
                  to={infiniteNestLink("/start")}
                  className="btn btn-primary"
                >
                  {t("START_MY_FREE_TRIAL")}
                </Link>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={CLARITI_TRIAL_TELL_ME_MORE_URL}
                  className="btn"
                >
                  {t("CLARITI_TELL_ME_MORE")}
                </a>
              </div>
            )}
          </>
        )}
        <Switch nest>
          <Route nest path="/start">
            <StartTrialModal refresh={refresh} />
          </Route>
        </Switch>
      </Loader>
    </Content>
  );
};
